module.exports = __webpack_public_path__ + "img/spring_showcase_logo.c3a49414.png";